<template>
  <div class>
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float">
        <!-- <div class="form-group">
                    <label for="">操作帐号：</label>
					<el-input v-model="search.type" placeholder="操作帐号："></el-input>
        </div>-->
        <div class="form-group">
          <label for="bdate">时间</label>
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            :editable="false"
            v-model="search.startTime"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </div>
        <div class="form-group">
          <label for="edate">至</label>
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            :editable="false"
            v-model="search.endTime"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </div>
        <div class="form-group others">
          <span class="search_btn">
            <button @click="searchList" type="button" class="btn btn-primary" id="search_btn">查询</button>
          </span>
          <!-- <span class="dowload"><ExportExcel v-bind:tableListData="this.tableListData" v-bind:tableListDataAll="this.tableListDataAll" v-bind:downloadFileds="this.downloadFileds"></ExportExcel></span> -->
          <!-- <span class="refresh_btn"><Refresh @tableList="this.tableList"></Refresh></span> -->
        </div>
      </form>
    </div>

    <div class="list-right">
      <el-table
        ref="table"
        border
        :data="tableListData.rows"
        height="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
      >
        <el-table-column  show-overflow-tooltip label="时间" prop="crtTime"></el-table-column>

        <el-table-column  show-overflow-tooltip label="错误源" prop="errorSource"></el-table-column>
        <el-table-column  show-overflow-tooltip label="异常描述" prop="errorDescribe"></el-table-column>
      </el-table>
    </div>
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { abnormalLogList } from "@/api/url";
import Page from "../../commons/page.vue";
import Refresh from "../../commons/refresh.vue";
export default {
  data() {
    return {
      styleObj: {
        "text-align": "center"
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB"
      },
      search: {
        pageNumber: 1,
        pageSize: 12,
        status: "",
        type: "",
        startTime: "",
        endTime: ""
      },
      tableListData: {
        rows: []
      },
      pageObj:{}
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList: function(curPage) {
      var _this = this;
      this.$get(abnormalLogList(), {
        // crtName:this.search.type,
        limit: this.search.pageSize,
        page: curPage,
        beginTime:this.search.startTime,
        endTime:this.search.endTime,
        enabledFlag:'y'
      }).then(data => {
        if (data.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total
        };
        // _this.getPage(pageObj);
        this.pageObj={...pageObj}
        _this.tableListData.rows = data.data.rows;
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },

    searchList: function() {
      var flTime = this.timeCompare(this.search.startTime, this.search.endTime);
      // console.log(this.search.endTime)
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (
        !Boolean(this.search.startTime) &&
        Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (
        Boolean(this.search.startTime) &&
        !Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    timeCompare: function(bDateVal, eDateVal) {
      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }
      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },
    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.type = "";
      this.search.startTime = "";
      this.search.endTime = "";
    }
  },
  computed: mapState({
    curIndex: state => state.page.curIndex,
    rowsCount: state => state.page.rowsCount
  }),
  components: {
    Page,
    Refresh
  },
  created: function() {
    this.tableList(this.search.pageNumber);
  },
  mounted: function() {}
};
</script>
<style scoped>
/* @import "@/assets/css/equip.css"; */
</style>